import type { AxiosError, InternalAxiosRequestConfig } from "axios";
import createAxiosInstance from "@/api/config/createAxiosInstance";
import type { ApiError } from "@/types/error";
import { WOO_CUSTOM_API_PATH_PROXY } from "@shared/config/constants";

const baseURL = WOO_CUSTOM_API_PATH_PROXY; // 呼叫專案中的 Serverless Function API 路由，並由該路由轉發請求至 WooCommerce Custom API

const handleRequestConfig = (config: InternalAxiosRequestConfig) => {
  config.params = {
    ...config.params,
  };

  return Promise.resolve(config);
};

const handleWooCustomApiResponseError = (error: AxiosError): ApiError | null => {
  // 請求已成功發出，且伺服器也響應了狀態碼，但狀態碼超出 2xx 範圍
  if (error.response) {
    const formattedError: ApiError = {
      status: error.response?.status || error.status || 0,
      data: error.response?.data?.error || error.response?.data,
      message:
        error.response?.data?.error?.data?.details?.message ||
        error.response?.data?.message ||
        error.message,
    };
    return formattedError;
  }

  // 如果沒有匹配的自定義邏輯，返回 null，讓通用邏輯處理
  return null;
};

const wooCustomApi = createAxiosInstance(
  baseURL,
  handleRequestConfig,
  handleWooCustomApiResponseError,
);

export { wooCustomApi };
